export default __webpack_public_path__ + "static/media/News & Announcements.b6a06eab.svg";